import { BoxProps as RestyleBoxProps, createBox } from "@shopify/restyle";
import { BackgroundColor, Theme, theme } from "@theme";
import React from "react";
import { ViewProps } from "react-native";
import Animated, { AnimatedProps } from "react-native-reanimated";
import LGradient, { LGradientProps } from "./LGradient";

const Box = createBox<Theme, AnimatedProps<ViewProps>>(Animated.View);

type RestyleProps = RestyleBoxProps<Theme>;
type AnimatedViewProps = AnimatedProps<ViewProps>;

type AllProps = RestyleProps & AnimatedViewProps;

export type BackgroundColorProp = {
  backgroundColor?: BackgroundColor | BackgroundColor[];
};
export type LBoxProps = Omit<AllProps, "backgroundColor"> &
  BackgroundColorProp &
  LGradientProps;

const LBox = React.forwardRef<Animated.View, LBoxProps>(function LBoxComp(
  { children, backgroundColor, locations, ...rest }: LBoxProps,
  ref,
) {
  if (Array.isArray(backgroundColor)) {
    const colors = backgroundColor.map(
      (color) => theme.colors[color as keyof typeof theme.colors],
    );

    return (
      <LGradient colors={colors as any} locations={locations as any} {...rest}>
        {children}
      </LGradient>
    );
  }

  return (
    <Box
      ref={ref}
      backgroundColor={backgroundColor as any}
      {...rest}
      layout={undefined}
    >
      {children}
    </Box>
  );
});

export default LBox;
